import { apiGetRoutes } from '@/api/permission'
import router, { constantRoutes } from '@/router'
import { PermissionState } from '@/types'
import { localStorage } from '@/utils/storage'
import path from 'path-browserify'
import { defineStore } from 'pinia'
import { RouteRecordRaw } from 'vue-router'
export const Layout = () => import('@/layouts/BasicLayout/index.vue')
const modules = import.meta.glob('../../pages/**/**.vue')
/**
 */
const setAllPath = (row: any, father?: string) => {
  let paths: any[] = []
  if (row.children && row.children.length) {
    const fatherPath = father ? father : row.path
    row.children.forEach((item: any) => {
      paths = paths.concat(setAllPath(item, path.join(fatherPath, item.path)))
    })
  } else if (row.name && father && !row.meta.hidden) {
    paths.push(father)
  }
  return paths
}

const filterRoleRoutes = (routes: RouteRecordRaw[], roles: string[]) => {
  let array = [] as RouteRecordRaw[]
  routes.forEach((item: RouteRecordRaw) => {
    if (item.children && item.children.length) {
      const arr = filterRoleRoutes(item.children, roles)
      if (arr && arr.length) {
        item.children = arr
        array = array.concat(item)
      }
      // @ts-ignore
    } else if (item.meta?.roles && item.meta?.roles.length) {
      roles.forEach((role) => {
        // @ts-ignore
        if (item.meta?.roles.includes(role)) {
          array.push(item)
        }
      })
    }
  })
  return array
}

export const filterAsyncRoutes = (routes: RouteRecordRaw[], roles: string[]) => {
  const res: RouteRecordRaw[] = []
  routes.forEach((route) => {
    const tmp = { ...route } as any
    if (tmp.component === 'Layout') {
      tmp.component = Layout
    } else if (tmp.component) {
      tmp.component = modules[/* @vite-ignore */ `../../pages/${tmp.component}.vue`]
    } else {
      tmp.component = modules[/* @vite-ignore */ `../../pages/ErrorPage/403.vue`]
    }
    res.push(tmp)
    if (tmp.children) {
      tmp.children = filterAsyncRoutes(tmp.children, roles)
    }
  })
  return res
}

const usePermissionStore = defineStore({
  id: 'permission',
  state: (): PermissionState => ({
    routes: localStorage.get('routes') || [],
    addRoutes: [],
  }),
  actions: {
    async RESET_STATE() {
      this.$reset()
    },
    setRoutes(routes: RouteRecordRaw[]) {
      this.addRoutes = routes
      this.routes = constantRoutes.concat(routes)
      localStorage.set('routes', this.routes || [])
    },
    /**
     * 获取系统菜单
     */
    GetRoutes(roles: string[]) {
      return new Promise((resolve, reject) => {
        apiGetRoutes()
          .then((response) => {
            const asyncRoutes = filterRoleRoutes(response.data, roles)
            const accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
            const routes: any[] = accessedRoutes.concat(constantRoutes).map((item: any) => {
              return setAllPath(item)
            })
            accessedRoutes.unshift({
              path: '/',
              redirect: [].concat(...routes)[0],
              name: 'home',
            })
            resolve(accessedRoutes)
            accessedRoutes.forEach((route) => {
              router.addRoute(route)
            })
            this.setRoutes(accessedRoutes)
          })
          .catch((e) => {
            reject([])
          })
      })
    },
  },
})

export default usePermissionStore
